<template>
    <div class="home">

        <HomePublic v-if="!$user.userId() || $user.isDisabled()"/>

        <HomeAdmin v-else-if="$user.isSuperAdmin()"/>

        <HomeAppAdmin v-else-if="$user.isAdmin()"/>

        <!--        Setup page for equipment owners-->
        <CompanyUserSetup
            v-else-if="$user.needsCompanyUserSetup()"
            :company-user="$user.danglingCompanyUser()"/>

        <!--        Setup page for project managers and owners reps-->
        <AgencyUserSetup
            v-else-if="$user.agencyUserNeedingSetup()"
            :agency-user="$user.agencyUserNeedingSetup()"/>

        <!--        Dashboard for Program Admins, Project Managers, and Owners Reps-->
        <HomeAgencyUser v-else-if="$user.isProjectManager() ||
                                   $user.isOwnersRepresentative() ||
                                   $user.isProgramAdmin()"/>

        <!--        Dashboard for Equipment Owners-->
        <HomeUser v-else-if="$user.isEquipmentOwner()"/>

        <HomeAuditor v-else-if="$user.isAuditor()"/>

        <div class="layout-small-form" v-else>
            <b-row class="justify-content-md-center">
                <b-col cols="12" md="6" md-offset="3">
                    <heading title="Your account has been deactivated"/>
                </b-col>
            </b-row>
        </div>
    </div>

</template>

<script>

import Vue from 'vue'
import HomeAdmin from '@/pages/HomeAdmin'
import HomePublic from '@/pages/HomePublic'
import HomeUser from '@/pages/HomeUser'
import HomeAgencyUser from '@/pages/HomeAgencyUser'
import HomeAppAdmin from './HomeAppAdmin'
import CompanyUserSetup from '@/pages/CompanyUserSetup'
import AgencyUserSetup from '@/pages/AgencyUserSetup'
import HomeAuditor from '@/pages/HomeAuditor'

/**
 * Home page - displays different components depending on user role
 */
export default Vue.extend({
    name: 'Home',
    components: {
        HomeAdmin,
        HomePublic,
        HomeUser,
        HomeAgencyUser,
        HomeAppAdmin,
        CompanyUserSetup,
        AgencyUserSetup,
        HomeAuditor,
    },
    async beforeMount () {
        //After users have logged in, present them with needed setup
        await this.$user.refresh()
    }
})
</script>

<style lang="scss">
.home {
    //padding-top: 1em;
}
</style>
